import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-white text-gray-400 text-center p-4">
            2025
            <span className="ml-1">
                <a
                    href="mailto:izzuddin@izzutech.com"
                    className="text-blue-600 hover:underline"
                >
                    IzzuTech
                </a>
            </span>

        </footer>
    );
};

export default Footer;